
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import Accordion from "@/components/UI/Accordion.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import defensiveCopy from "@/util/defensive-copy";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { getDynamicPathAcceptsItems } from "@/lib/dynamic-data/utils";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import { propertyPathRule } from "@/lib/elements/utils";
import {
  DynamicFieldReturnType,
  DynamicPropertyPath
} from "@/types/dynamic-property-path";

@Component({
  components: {
    Repeater,
    DropdownInput,
    CodeInput,
    Dropdown,
    Accordion,
    draggable
  }
})
export default class ElementStudioDynPropPaths extends Vue {
  @Prop({ default: () => [] })
  value!: DynamicPropertyPath[];

  @Prop({ default: () => [] })
  allPaths!: string[];

  updateElementValue(newValue: DynamicPropertyPath[]) {
    this.$emit("input", newValue);
  }

  updateDynamicPropertyPath(index: number, newPath: string) {
    const newValue = defensiveCopy(this.value);

    if (!this.pathRules(newPath)) {
      return;
    }

    newValue[index].path = newPath.trim();
    this.updateElementValue(newValue);
  }

  pathRules(newPath: string) {
    return propertyPathRule(newPath);
  }

  get getDynamicPathAcceptsItems() {
    return getDynamicPathAcceptsItems();
  }

  updateValue(index: number, newAccepts: DynamicFieldReturnType) {
    const newValue = defensiveCopy(this.value);

    newValue[index].accepts = newAccepts;
    this.updateElementValue(newValue);
  }
}
